import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import checkPermission from '../../../../../Components/Hooks/PermissionHook';
import { setVersionDetails } from '../../../../../slices/campaigns/reducer';
import { toggleDuplicateSetModal } from '../../../../../slices/modals/reducer';

function DuplicateVersionBtn() {
  const dispatch = useDispatch();

  async function showDuplicate() {
    dispatch(setVersionDetails());
    dispatch(toggleDuplicateSetModal())
  }

  const selectMenuPath = createSelector(state => state.MenuData, state => ({
    brandPath: state.brandPath,
    marketPath: state.marketPath,
  }));
  const { brandPath, marketPath } = useSelector(selectMenuPath);

  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "campaignEdit")) {
    return (
      <button className='btn btn-icon btn-soft-primary' onClick={showDuplicate}>
        <i className='mdi mdi-file-multiple-outline'></i>
      </button>
    );
  } else {
    return null;
  }

}

export default DuplicateVersionBtn
